import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=7b9aa6c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9aa6c1"]])

export default __exports__